import React from 'react';

interface PaymentMethodItemProps {
    expanded: boolean;
    onToggle?: () => void;
    children: React.ReactNode;
    className?: string; // Additional classes for the container
}

const PaymentMethodItem: React.FC<PaymentMethodItemProps> = ({ expanded, onToggle, children, className = '' }) => {
    return (
        <div
            className={`border-[1px] rounded-[6px] p-[20px] bg-white transition-all duration-200 ${expanded ? 'border-[#030407]' : 'border-[#D0D5DD]'} ${!expanded ? 'cursor-pointer hover:border-gray-400' : ''} ${className}`}
            onClick={() => {
                if (!expanded && onToggle) {
                    onToggle();
                }
            }}
        >
            {children}
        </div>
    );
};

export default PaymentMethodItem;
